import React from "react";

import Placeholder, { Rect } from "components/Placeholder";

const SearchFiltersPlaceholder: React.FC<{
  count?: number;
}> = ({ count = 5 }) => (
  <div className="mb-md">
    <Placeholder width="55" height="14" className="mb-sm">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <div className="flex flex-row gap-4 items-center">
      <Placeholder width="70" height="24" className="rounded-full">
        <Rect width="100%" height="100%" />
      </Placeholder>
      {new Array(count).fill(null).map((_, i) => (
        <Placeholder
          width="70"
          height="14"
          key={`search-filter-placeholder-${i}`}
        >
          <Rect width="100%" height="100%" />
        </Placeholder>
      ))}
    </div>
  </div>
);

export default SearchFiltersPlaceholder;
